import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { Autocomplete, Box, Card, TextField, Tooltip, Typography } from '@mui/material';
import RestAPIService from '../../../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../../../Utility/API/Serviceurls';
import ToastMsg from '../../../../../../Components/ToastMsg/ToastMsg';
import { ImagePaths } from "../../../../../../Utility/ImagePaths";
import CommonValidation from '../../../../../../Components/CommonFunctions/CommonValidation';
import { localGetItem } from '../../../../../../Utility/Services/CacheProviderService';
import { ToolsFieldWithMic } from '../../../../../../Components/Common Components/CommonComponents';
import { Colors } from '../../../../../../Styles/Colors';

const change_data_obj = {
    "Discharge notes": 'discharge_notes',
    "Family Counselling": 'family_counselling',
    "Medication & Instructions": 'instructions',
    "Doctor Notes": 'write_notes',
};

class SarasWriteNotes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            notesTxt: this.props.doctorTxt,
            notesData: this.props.doctorsData,
            IpPatientData: this.props?.IpPatientData,
            withOutAppointment: this.props?.withOutAppointment,
            listenPopUp: false,
            clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')),
            selectedDoctor: null,
            DoctorsList: [],
            HistoryList: this.props?.HistoryList,
        }
    }

    componentDidMount() {
        this.getDoctorsList();
    }

    componentDidUpdate(prevprops) {
        if ((JSON.stringify(prevprops.doctorTxt) !== JSON.stringify(this.props.doctorTxt)) && this.props.doctorTxt) {
            this.setState({ notesTxt: this.props.doctorTxt });
        }

        if ((JSON.stringify(prevprops.doctorsData) !== JSON.stringify(this.props.doctorsData)) && this.props.doctorsData) {
            this.setState({ notesData: this.props.doctorsData });
        }

        // Clear notesTxt when isClearClked is true
        if (prevprops.isClearClked !== this.props.isClearClked && this.props.isClearClked) {
            let updatedNotes = { ...this.state.notesTxt };
            updatedNotes.notes = "";
            this.setState({ notesTxt: { ...updatedNotes } },
                () => { this.props.onSaveComplete(); });
        }
        // Call save when isSaveClked is true
        if (prevprops.isSaveClked !== this.props.isSaveClked && this.props.isSaveClked) {
            this.Validation();
        }
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    getDoctorsList() {
        try {
            let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
            let DoctorClinicId = localGetItem('SelectedDoctorClinicId');
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME + `?clinic_id=${UserData?.clinic_id ? UserData?.clinic_id : DoctorClinicId}`).
                then((response) => {
                    if (response.data.status === "success") {
                        let listData = response.data.data?.length > 0 ? response.data.data : []
                        this.setState({
                            DoctorsList: listData
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((e) => {
                    this.errorMessage(e.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    postNotes = () => {
        try {
            const { notesTxt, clinic_id } = this.state;
            const { IpPatientData, label, CallgetApi, callhistoryApi } = this.props;
            const myUser = JSON.parse(localGetItem("loggedInUserInfo"));
            if(myUser.module_name == "front_office" && this.state.selectedDoctor == null){
                this.errorMessage("Kindly select the doctor")
            }else{
                var data = {
                // "id": notesTxt?.id,
                "doctor_id": this.state.selectedDoctor ? this.state.selectedDoctor.doctor_id : (notesTxt?.doctor_id || myUser?.doctor_id || IpPatientData?.doctor_id),
                "clinic_id": clinic_id,
                "ip_admission_id": IpPatientData?.id,
                "change_data": change_data_obj[label],
                // "notes": CommonValidation.removeSpace(notesTxt.notes)
                "notes": notesTxt.notes
            }
            RestAPIService.create(data, Serviceurls.IP_DOC_WRITE_NOTES)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.successMessage(response.data.message);
                        CallgetApi();
                        callhistoryApi();
                    } else {
                        this.errorMessage(response.data.message);
                    }
                }).catch(error => {
                    if (error?.response?.data?.status === "fail") {
                        this.errorMessage(error.response.data.message);
                    } else {
                        this.errorMessage(error.message);
                    }
                }).finally(() => {
                    this.props.onSaveComplete();
                });
            }
        } catch (error) {
            this.errorMessage(error.message);
        }
    }

    Validation = () => {
        var states = this.state
        if (CommonValidation.removeSpace(states.notesTxt.notes) !== "") {
            this.postNotes()
        } else {
            this.errorMessage(`Enter ${this.props.label}`)
            this.props.onSaveComplete();
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    handleChange = (textEditorValue) => {
        let updatedNotes = { ...this.state.notesTxt };
        updatedNotes.notes = textEditorValue;
        this.setState({
            notesTxt: { ...updatedNotes }
        }, () => {
            this.Validation()
        })
    }

    clearEditor = () => {
        let updatedNotes = { ...this.state.notesTxt };
        updatedNotes.notes = "";
        this.setState({ notesTxt: { ...updatedNotes } },
            () => { this.props.onSaveComplete(); });
    }

    render() {
        let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
        return (
            <Box className="" p={'0.5rem'} display={"flex"} gap={3} style={{ height: "-webkit-fill-available" }} >
                <div style={{ width: "65%" }}>
                    {UserData?.module_name == "front_office" ? <Autocomplete
                        size='small'
                        options={this.state?.DoctorsList}
                        getOptionLabel={(option) => (option?.doctor_name)}
                        value={this.state.selectedDoctor ? this.state?.selectedDoctor : null}
                        onChange={(event, newValue) => {
                            this.setState({
                                selectedDoctor: newValue,
                            })
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={'Select Doctor *'}
                                style={{ width: "20dvw" }}
                            />
                        )}
                    /> : null }
                    <ToolsFieldWithMic
                        Title={"Progressive Notes"}
                        EditorRef={this.state.notesTxt?.notes || ""}
                        EditorDisable={false}
                        minHeight={"20dvh"}
                        EditorHeight={"auto"}
                        overallHeight={"auto"}
                        clearEditorText={this.clearEditor}
                        isFrom="Doctor Notes"
                        handlePost={this.handleChange.bind(this)}
                        disableSave={this.props.checkuserAccess || false}
                        errorMsg={this.errorMessage.bind(this)}
                        maxChar={10000}
                    />
                </div>
                <Card sx={{ overflowY: 'auto', padding: '0.625dvw', width: "35%" }}>
                    <Box component={'div'} borderBottom={'1px solid lightgray'} pb={'0.5rem'}>
                        <Typography fontWeight={600} fontSize={'0.9rem'} color={Colors.SecondaryText}>History</Typography>
                    </Box>
                    <div style={{ margin: "10px 0px" }}>
                        {
                            this.props.HistoryList?.progressive_notes?.length > 0 ? this.props.HistoryList?.progressive_notes?.map((item, index) => {
                                let modified_by = item?.modified_by || item?.created_by || '-'
                                let time = item?.modified_date || '-'
                                return (
                                    <Box component={'div'} key={index}>
                                        <Box component={'div'} display={'flex'} alignItems={'center'} mb={'0.5rem'}>
                                            <Box component={'img'} src={ImagePaths.Doctor_Icon.default} alt='' height={'3dvh'} width={'1.2dvw'} sx={{ mr: '0.5rem' }} />
                                            {modified_by?.length > 15 ? <Tooltip placement='top' modified_by={modified_by}><Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{modified_by?.slice(0, 15) + '...'}</Typography></Tooltip> :
                                                <Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{modified_by}</Typography>}
                                            <Box display={'flex'} alignItems={'center'}>
                                                <Box component={'img'} src={ImagePaths.Clock.default} alt='' height={'3dvh'} width={'1.2dvw'} sx={{ mr: '0.5rem' }} />
                                                {time?.length > 25 ? <Tooltip placement='top' title={time}><Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{time?.slice(0, 25) + '...'}</Typography></Tooltip> :
                                                    <Typography fontSize={'0.9rem'} fontWeight={600} mr={'0.5rem'}>{time}</Typography>}
                                            </Box>
                                        </Box>
                                        <Box component={'div'} mb={'0.5rem'}>
                                            <Box><Typography fontSize={'0.9rem'} color={Colors.SecondaryText} fontWeight={600}>Previous Value</Typography></Box>
                                            <Typography fontSize={'1rem'} >{"Doctor Name : " + item?.doctor_name}</Typography>
                                            <Box display={'flex'} flexWrap={'wrap'}>
                                                {item?.previous_val ? item?.previous_val?.length > 80 ?
                                                    <Tooltip placement='top'
                                                        title={<Box sx={{ overflow: 'scroll', maxHeight: '40dvh' }}
                                                            dangerouslySetInnerHTML={{ __html: item?.previous_val }}
                                                        />}><Typography ml={'0.5rem'}
                                                            dangerouslySetInnerHTML={{ __html: item?.previous_val?.slice(0, 78) + "..." }} fontSize={'0.9rem'} /></Tooltip> : <Typography ml={'0.5rem'} dangerouslySetInnerHTML={{ __html: item?.previous_val || "-" }} fontSize={'0.9rem'} /> : '-'}
                                            </Box>
                                        </Box>
                                    </Box>
                                )
                            }) : null
                        }
                    </div>
                </Card>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
            </Box>
        )
    }
}
export default withTranslation()(SarasWriteNotes)